import { render, staticRenderFns } from "./RatingLine.vue?vue&type=template&id=0d52b31f&scoped=true&"
import script from "./RatingLine.vue?vue&type=script&lang=js&"
export * from "./RatingLine.vue?vue&type=script&lang=js&"
import style0 from "./RatingLine.vue?vue&type=style&index=0&id=0d52b31f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d52b31f",
  null
  
)

export default component.exports